// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderInfoItemStatus-modulestatus__XF4S8";
export { _1 as "status" }
